import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {DisplayContainer, DisplayItem} from './style'


export const DisplayRow = ({data}) => {

    const tiles = data.tiles.map((data) => {
        return(
            <Col key={data.id}>
            <DisplayItem>
                
            </DisplayItem>
            </Col>
        )
    })

    return (
        <>
            <DisplayContainer>
            <Container fluid>
                <Row>
                    {tiles}
                </Row>
            </Container>
            </DisplayContainer>
        </>
    )
}
